import { lazy } from 'react';
import { useTranslation } from 'react-i18next';

import { IconaTutorial } from '@/components/tutorial/IconaTutorial';
import { chiaveTutorialVisto } from '@/lib/storage';

import { GiocaScala40 } from './GiocaScala40';
import { TavoliMieiScala40 } from './TavoliMieiScala40';

/**
 * Il livello del tutorial (I-1218), pigro: un chunk a parte che si scarica solo quando si apre. L'annotazione PURE e NECESSARIA (`IconaTutorial.tsx`): senza, `lazy(...)` resta nell'entry. Questo file lo
 * montano SOLO `HubSections` e la rotta dentro il confronto letterale del flag: in produzione ne la Hub ne il chunk ci sono (`tools/verify-scala40.ts`).
 */
const LivelloTutorial = /*#__PURE__*/ lazy(() => import('./TutorialScala40').then((m) => ({ default: m.TutorialScala40 })));

/**
 * La Hub della scala 40 (sul modello di `HubGinRummy`): col gioco attivo = Scala 40 la Hub non ha la riga delle sezioni, ha DUE blocchi — «Gioca» (il formato da 2 a 6, Gioca, Invita un amico, Entra con un codice) e
 * «I miei tavoli / Riprendi» — dentro UN solo scorrevole. Ranked e tornei vengono dopo. La stessa Hub e la pagina `/scala40` (`routes/scala40/Scala40Home.tsx`).
 *
 * ⚠️ Lo montano `HubSections` e la rotta SOLO dentro il confronto LETTERALE del flag `VITE_FEATURE_SCALA40_ENABLED` (che il bundler piega): questo file e il marcatore `data-hub-scala40` non sono in produzione.
 * La serratura (`beta`, Limulo acceso) sta in `HubSections`, nel selettore e nel `RoleGate` della rotta.
 */
export function HubScala40() {
  const { t } = useTranslation('scala40');
  return (
    <div data-hub-scala40 className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain py-2 [touch-action:pan-y]">
      {/* il tutorial (I-1218): l'icona sta solo qui, nella Hub, mai in una partita ne nell'Attesa; una chiave sola sul dispositivo */}
      <div data-riga-tutorial className="flex shrink-0 justify-end px-1">
        <IconaTutorial Livello={LivelloTutorial} chiave={chiaveTutorialVisto('scala40')} nome={t('tutorial.icona.nome')} nuovo={t('tutorial.icona.nuovo')} />
      </div>
      <GiocaScala40 />
      <TavoliMieiScala40 />
    </div>
  );
}
